export default {
  path: '/student',
  redirect: '/student/dashboard',
  component: () => import('../layouts/main/Main.vue'),
  children: [
    {
      path: 'dashboard',
      name: 'student-dashboard',
      component: () => import('../views/pages/student/Home.vue'),
      meta: { title: 'Dashboard', requiresAuth: 'student' },
    },
    {
      path: 'workplace-safety',
      name: 'workplace-safety',
      component: () =>
        import(
          '../views/WorkExperiences/components/Prework/Student/WorkplaceSafety/WorkplaceSafety.vue'
        ),
      meta: { title: 'Workplace Safety', requiresAuth: 'student' },
    },
    {
      path: 'workplace-preparation',
      name: 'workplace-preparation',
      component: () =>
        import(
          '../views/WorkExperiences/components/Prework/Student/WorkplacePreparation/WorkplacePreparation.vue'
        ),
      meta: { title: 'Workplace Preparation', requiresAuth: 'student' },
    },
    {
      path: 'workplace-preparation/module/:id',
      name: 'workplace-preparation-module',
      component: () =>
        import(
          '../views/WorkExperiences/components/Prework/Student/WorkplacePreparation/WorkplacePreparationModule.vue'
        ),
      meta: { title: 'Workplace Preparation Module', requiresAuth: 'student' },
    },
    {
      path: 'apply',
      name: 'apply',
      component: () =>
        import('../views/WorkExperiences/components/Prework/Student/Apply/Apply.vue'),
      meta: { title: 'Apply for a Position', requiresAuth: 'student' },
    },
    {
      path: 'reflection/virtual',
      name: 'reflection-virtual',
      component: () =>
        import('../views/WorkExperiences/components/Postwork/ReflectionEditable.vue'),
      meta: {
        title: 'Reflection',
        requiresAuth: 'student',
        type: 1,
      },
    },
    {
      path: 'reflection/in-person',
      name: 'reflection-in-person',
      component: () =>
        import('../views/WorkExperiences/components/Postwork/ReflectionEditable.vue'),
      meta: {
        title: 'Reflection',
        requiresAuth: 'student',
        type: 2,
      },
    },
    {
      path: 'thank-you-letter',
      name: 'thank-you-letter',
      component: () =>
        import('../views/WorkExperiences/components/Postwork/ThankYouLetterEditable.vue'),
      meta: { title: 'Thank you Letter', requiresAuth: 'student' },
    },
    {
      path: 'certificates',
      name: 'certificates',
      component: () => import('../views/pages/student/PostWorkExperience/Certificate.vue'),
      meta: { title: 'Certificates', requiresAuth: 'student' },
    },
    {
      path: 'work-experience-router',
      name: 'work-experience-router',
      component: () => import('../views/WorkExperiences/components/WorkExperience/Main.vue'),
      meta: { title: 'Work experience', requiresAuth: 'student' },
    },
    {
      path: 'available-experiences',
      name: 'available-experiences',
      component: () =>
        import('../views/WorkExperiences/components/WorkExperience/AvailableExperiences.vue'),
      meta: { title: 'Start a Virtual Experience', requiresAuth: 'student' },
    },
    {
      path: 'experiences/completed',
      name: 'experiences-completed',
      component: () => import('../views/pages/student/vje/ExperiencesCompleted.vue'),
      meta: { title: 'Completed Virtual Experience', requiresAuth: 'student' },
    },
    {
      path: 'experiences/continue',
      name: 'experiences-continue',
      component: () => import('../views/pages/student/vje/ExperiencesContinue.vue'),
      meta: { title: 'Continue a Virtual Experience', requiresAuth: 'student' },
    },
    {
      path: 'experiences/complete_prework',
      name: 'complete_prework',
      component: () =>
        import('../views/WorkExperiences/components/Prework/Student/NotCompleted.vue'),
      meta: { title: 'Pre-Work Not Complete', requiresAuth: 'student' },
    },
    {
      path: 'work-experience-completed',
      name: 'vje-completed',
      component: () => import('../views/WorkExperiences/components/WorkExperience/Completed.vue'),
      meta: { title: 'Work Experience Complete', requiresAuth: 'student' },
    },
    {
      path: 'work-experience-info/:activity/:slug',
      name: 'info-student',
      component: () => import('../views/WorkExperiences/components/Infopage.vue'),
      meta: { title: 'Work Experience Information', requiresAuth: 'student' },
    },
    {
      path: 'work-experience/:id',
      name: 'work-experience',
      redirect: '/student/work-experience/:id/tour_and_induction',
      component: () =>
        import('../views/WorkExperiences/components/WorkExperience/ExperienceMain.vue'),
      meta: { title: 'Work experience', requiresAuth: 'student' },
      children: [
        {
          path: 'experience-info',
          name: 'we-experience-info',
          component: () =>
            import('../views/WorkExperiences/components/WorkExperience/ExperienceInfo.vue'),
          meta: { title: 'Experience Information', requiresAuth: 'student' },
        },
        {
          path: 'introduction',
          name: 'we-introduction',
          component: () =>
            import('../views/WorkExperiences/components/WorkExperience/Introduction.vue'),
          meta: { title: 'Introduction', requiresAuth: 'student' },
        },
        {
          path: 'learning_and_resources',
          name: 'we-learning_and_resources',
          component: () => import('../views/WorkExperiences/components/LearningResources.vue'),
          meta: { title: 'Learning & Resources', requiresAuth: 'student' },
        },
        {
          path: 'tour_and_induction',
          name: 'we-tour_and_induction',
          component: () => import('../views/WorkExperiences/components/TourInduction.vue'),
          meta: { title: 'Tour & Induction', requiresAuth: 'student' },
        },
        {
          path: 'projects',
          name: 'we-projects',
          component: () => import('../views/WorkExperiences/components/Projects.vue'),
          meta: { title: 'Projects', requiresAuth: 'student' },
        },
        {
          path: 'activities',
          name: 'we-activities',
          component: () => import('../views/WorkExperiences/components/Activities.vue'),
          meta: { title: 'Activities', requiresAuth: 'student' },
        },
        {
          path: 'reflection',
          name: 'we-reflection',
          component: () =>
            import('../views/WorkExperiences/components/Postwork/ReflectionReadOnly.vue'),
          meta: { title: 'Reflection', requiresAuth: 'student' },
        },
        {
          path: 'reflection/edit',
          name: 'we-reflection-edit',
          component: () =>
            import('../views/WorkExperiences/components/Postwork/ReflectionEditable.vue'),
          meta: {
            title: 'Edit Reflection',
            requiresAuth: 'student',
            showTips: false,
            canChooseReflection: false,
            autoSelectReflection: true,
          },
        },
        {
          path: 'thankyou_letter',
          name: 'we-thankyou_letter',
          component: () =>
            import('../views/WorkExperiences/components/Postwork/ThankyouLetterReadOnly.vue'),
          meta: { title: 'Thank you Letter', requiresAuth: 'student' },
        },
        {
          path: 'thankyou_letter/edit',
          name: 'we-thankyou_letter-edit',
          component: () =>
            import('../views/WorkExperiences/components/Postwork/ThankYouLetterEditable.vue'),
          meta: {
            title: 'Edit Thank you Letter',
            requiresAuth: 'student',
            showTips: false,
            canChooseItem: false,
            autoSelectTL: true,
          },
        },
        {
          path: 'certificate',
          name: 'we-certificate',
          component: () => import('../views/WorkExperiences/components/Postwork/Certificate.vue'),
          meta: { title: 'Certificate', requiresAuth: 'student' },
        },
        {
          path: 'activities/:slug',
          name: 'activity-student',
          component: () => import('../views/WorkExperiences/components/Activity.vue'),
          meta: { title: 'Activity', requiresAuth: 'student' },
        },
      ],
    },
    {
      path: 'help',
      name: 'studenthelp',
      component: () => import('../views/pages/student/Help.vue'),
      meta: { title: 'Help', requiresAuth: 'student' },
    },
    {
      path: 'real-world-experience',
      name: 'student-realworldexperience',
      component: () => import('../views/pages/student/vje/RealWorkExperience.vue'),
      meta: { title: 'Add Experience', requiresAuth: 'student' },
    },
    {
      path: 'notifications',
      name: 'student-notifications',
      component: () => import('../views/pages/Notifications.vue'),
      meta: { title: 'Notifications', requiresAuth: 'student' },
    },
    {
      path: 'logout',
      name: 'studentlogout',
      component: () => import('../views/pages/student/Logout.vue'),
      meta: { title: 'Log Out', requiresAuth: 'student' },
    },
  ],
};
